/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Recovery_EyebrowInputs */

const en_us2_native_release_widget_recovery_eyebrow = /** @type {(inputs: Native_Release_Widget_Recovery_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle readiness`)
};

const pt_br2_native_release_widget_recovery_eyebrow = /** @type {(inputs: Native_Release_Widget_Recovery_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prontidão muscular`)
};

const pt_pt2_native_release_widget_recovery_eyebrow = /** @type {(inputs: Native_Release_Widget_Recovery_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prontidão muscular`)
};

/** @type {(inputs: Native_Release_Widget_Recovery_EyebrowInputs) => LocalizedString} */
const es_419_native_release_widget_recovery_eyebrow = en_us2_native_release_widget_recovery_eyebrow;

/** @type {(inputs: Native_Release_Widget_Recovery_EyebrowInputs) => LocalizedString} */
const fr_fr2_native_release_widget_recovery_eyebrow = en_us2_native_release_widget_recovery_eyebrow;

/** @type {(inputs: Native_Release_Widget_Recovery_EyebrowInputs) => LocalizedString} */
const de_de2_native_release_widget_recovery_eyebrow = en_us2_native_release_widget_recovery_eyebrow;

/** @type {(inputs: Native_Release_Widget_Recovery_EyebrowInputs) => LocalizedString} */
const it_it2_native_release_widget_recovery_eyebrow = en_us2_native_release_widget_recovery_eyebrow;

/**
* | output |
* | --- |
* | "Muscle readiness" |
*
* @param {Native_Release_Widget_Recovery_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_recovery_eyebrow = /** @type {((inputs?: Native_Release_Widget_Recovery_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Recovery_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_recovery_eyebrow(inputs)
	if (locale === "es-419") return es_419_native_release_widget_recovery_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_recovery_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_recovery_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_recovery_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_recovery_eyebrow(inputs)
	return en_us2_native_release_widget_recovery_eyebrow(inputs)
});
export { native_release_widget_recovery_eyebrow as "native-release.widget_recovery_eyebrow" }